'use strict'

import {
  initAll,
  setUserId,
  identify,
  track as ampTrack,
  reset,
  Identify,
} from '@amplitude/unified'

const API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY || 'cb976a19ede4e566b6acd4dab3e332a0'

let initialized = false

export function initAmplitude() {
  if (initialized || !API_KEY) return
  initAll(API_KEY, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  })
  initialized = true
}

export function identifyUser(user, tenant) {
  if (!initialized) return
  if (user?.id) setUserId(user.id)
  const event = new Identify()
  if (user?.email)  event.set('email', user.email)
  if (user?.name)   event.set('name', user.name)
  if (tenant?.id)   event.set('tenant_id', tenant.id)
  if (tenant?.name) event.set('tenant_name', tenant.name)
  identify(event)
}

export function track(event, properties = {}) {
  if (!initialized) return
  ampTrack(event, properties)
}

export function resetUser() {
  if (!initialized) return
  reset()
}
